<template>
  <div id="page-wrapper" class="login-page-wrapper">
    <div class="mw-100" id="page">
      <div class="main-page-content">
        <div id="main-wrapper" class="layout-main-wrapper clearfix">
          <div id="main" class="container">
            <div class="row row-offcanvas row-offcanvas-left clearfix">
              <main class="main-content col content-full-width" id="content" role="main">
                <section id="login" class="section">
                  <div class="d-login-container">
                    <div class="fptitle">
                      <span>{{ $t('message.vitamins') }}</span>
                      <span class="text-lowercase">{{ $t('message.for') }}</span>
                      <img src="@/assets/images/destiny.png"
                           class="login-logo"
                           alt=""></div>
                    <span>
                      {{ $t('message.register_a_new_account') }}
                    </span>
                    <user-form :type="'register'"></user-form>
                  </div>
                </section>
              </main>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import store from "../../store/store";
  import Userform from "../Users/Userform";

  export default {
    components: {
      userForm: Userform,
    },
    data() {
      return {
        email: '',
        password: '',
        confirmpassword: '',
        firstname: '',
        lastname: '',
        valid: true
      }
    },
    methods: {
      validate() {
        let valid = true;
        if (this.password !== this.confirmpassword) {
          valid = false;
        }
        return valid;
      },
      onSubmit() {
        if (this.validate()) {
          const formData = {
            email: this.email,
            username: this.email,
            password: this.password,
            firstname: this.firstname,
            lastname: this.lastname,
          };
          store.dispatch('signup', formData)
        }


      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Account/Register.vue